module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qIGrra/CoverDesign.jpg?1685327252831",
      "alt": "This image is the cover for the book A Fine Romance"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Fine Romance\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Benji Rao, a hard-working welder from the Pacific Northwest, is recovering from a life-threatening and life-changing injury at a posh California resort. Trouble is, he’s miserable. His friends are worried, his panic attacks are getting worse, and the guy in the bungalow next to his is none other than Jamie Durham—the kind of neighbor who plays music loud, blows everybody’s breakers, and doesn’t care what people think of him.")]), _vm._v(" "), _c('p', [_vm._v("But there’s more to Jamie than late nights, a huge inheritance, and a wild reputation. After endless bad press, Jamie longs for a chance to live a normal life, without the rumors and innuendo, and without his growing concern that he might be going crazy.")]), _vm._v(" "), _c('p', [_vm._v("When Ben finds himself desperate for a date and Jamie is the only option, Jamie can’t believe his luck—a date with Ben would be as normal as it gets. But when the date doesn’t exactly go as planned, Ben and Jamie must overcome their personal demons to find their way to love.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      T. Neilson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0